import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "VioQbase - Voice-Powered AI Knowledge Base for Enterprise Teams",
  description = "Transform your workplace efficiency with VioQbase's voice-activated AI knowledge base. Get instant answers, eliminate delays, and boost productivity for HR, IT, Healthcare, Finance, Legal, and University teams.",
  keywords = "AI knowledge base, voice AI, enterprise software, workplace efficiency, HR automation, IT support, healthcare AI, voice assistant, smart workplace, productivity tools, VioQbase",
  canonical = "https://vioqbase.com/",
  ogImage = "https://vioqbase.com/images/vioqbase-og-image.jpg",
  ogType = "website",
  twitterCard = "summary_large_image",
  jsonLd = null,
  noindex = false
}) => {
  const fullTitle = title.includes('VioQbase') ? title : `${title} | VioQbase`;
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      
      {/* Robots */}
      {noindex ? (
        <meta name="robots" content="noindex, follow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="VioQbase" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="twitter:site" content="@VioQbase" />
      
      {/* Structured Data */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;